import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SEOSection() {
  return (
    <section className="section-padding bg-background-100">
      <div className="container-main">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
            亚洲一级日本 —— 您的一站式日本内容导航平台
          </h2>

          <div className="prose prose-sm max-w-none text-foreground-600 space-y-4">
            <p>
              <strong>亚洲一级日本精选内容导航</strong>致力于为中文用户提供最全面、最权威的日本相关内容聚合服务。
              我们按照八大一级类目精心组织内容，涵盖<strong>日本文化</strong>、<strong>日本影视</strong>、<strong>日本美食</strong>、
              <strong>日本旅游</strong>、<strong>日本动漫</strong>、<strong>日本音乐</strong>、<strong>日本时尚</strong>和
              <strong>日本科技</strong>等领域，帮助用户高效地获取所需的<strong>亚洲一级日本资源导航</strong>信息。
            </p>

            <p>
              无论您是想深入了解<strong>日本一级文化推荐</strong>，还是寻找<strong>亚洲一级日本旅游攻略</strong>，
              亦或是关注最新的<strong>亚洲一级日本影视</strong>动态，我们的平台都能为您提供经过编辑团队严格筛选的优质内容。
              我们坚持日更的频率，确保内容的时效性和权威性。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-8">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2 px-3 py-2.5 bg-background-50 rounded-md border border-background-200/70 hover:border-primary-300 hover:text-primary-600 transition-all duration-200 text-sm text-foreground-700 font-medium"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-500 text-xs`}></i>
                  </span>
                  {cat.name}
                </Link>
              ))}
            </div>

            <p className="mt-8">
              <strong>亚洲一级日本内容分类</strong>系统是我们平台的核心特色。我们将海量的日本相关信息按照统一的标准进行归类整理，
              让用户不必在海量信息中迷失方向。每个分类下还有更细致的标签系统，支持用户精准定位感兴趣的话题。
              我们坚信，<strong>亚洲顶级日本资讯</strong>应该以结构化、系统化的方式呈现，让每位用户都能轻松找到最具价值的内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}